import React, { useState, useEffect, useRef } from "react";
/* import { TieredMenu } from 'primereact/tieredmenu';
import { OverlayPanel } from 'primereact/overlaypanel';
import { ScrollPanel } from 'primereact/scrollpanel'; */
// import { Image } from 'primereact/image';
import { Link, useNavigate } from "react-router-dom";
import { Auth } from 'aws-amplify';
import { reactLocalStorage } from 'reactjs-localstorage';
/* import NewAgreementLogo from '../../../src/assets/images/new_agreement_logo.svg';
import ProfileIMG from '../../../src/assets/images/profile.png'; */
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { Checkbox } from "primereact/checkbox";
import { toast } from "react-toastify";

import { GetAWSObjectURL } from "../../helper/aws";

export default function PSAConsultant(props) {

  console.log("props--", props);

  const menu = useRef(null);
  const notification = useRef(null);
  const mail = useRef(null);
  var myNavigation = useNavigate();


  const [checkYes1, setCheckYes1] = useState(false)
  const [checkNo1, setCheckNo1] = useState(false)
  const [checkYes2, setCheckYes2] = useState(false)
  const [checkNo2, setCheckNo2] = useState(false)
  const [checkYes3, setCheckYes3] = useState(false)
  const [checkNo3, setCheckNo3] = useState(false)
  const [selectedFileName, setSelectedFileName] = useState('');
  const [selectedFileNames, setSelectedFileNames] = useState('');



  const downloadFile = async (filename, file_url) => {
    // Replace 'your_file_url_here' with the actual URL of the file you want to download
    const fileUrl = file_url;
    let filePathURL = await GetAWSObjectURL(fileUrl);
    const imageBlob = await fetch(filePathURL).then(response => response.blob());
    const url = window.URL.createObjectURL(imageBlob);
    // Create an anchor element to trigger the download
    const link = document.createElement('a');
    link.href = url;
    link.download = filename; // You can specify the name for the downloaded file here
    link.target = '_blank'; // Opens the link in a new tab/window
    link.rel = 'noopener noreferrer';

    // Trigger the download
    link.click();

    // Clean up the anchor element
    //document.body.removeChild(link);
  };

  const items = [
    // {
    //   label: 'View profile',
    //   icon: 'gusd-user',
    //   url: '/initiatorprofile'
    // },
    {
      label: 'Change Password',
      icon: 'gusd-lock',
      url: '/changepassword'
    },
    {
      label: 'Switch Account',
      icon: 'gusd-switch-account',
      items: [
        {
          label: 'Admin'
        },
        {
          label: 'Initiator'
        },
        {
          label: 'Approver'
        },
        {
          label: 'Payroll'
        },
        {
          label: 'PSA Consultant'
        },
        {
          label: 'Initiators After Board Meeting'
        }
      ]
    },
    {
      separator: true
    },
    {
      label: 'Log out',
      icon: 'gusd-logout',
      command: async () => {
        await Auth.signOut({ global: false });
        reactLocalStorage.clear();
        myNavigation('/');
      }
    }
  ];

  const [activeTabIndex, setActiveTabIndex] = useState(0);


  function validateFileExtension(file_field, allowedExtensions) {
    let flag = false;
    let extension = file_field.substr(file_field.lastIndexOf(".") + 1).toLowerCase();
    if (allowedExtensions.indexOf(extension) === -1) {
      flag = true;
    }
    return flag;
  }

  async function uploadDocumentsFile(e) {

    let file = e.target.files;
    let file_field = file[0].name;
    let allowedExtensions = ["pdf","png","jpg","gif","svg"];
    let flag = false;
    flag = validateFileExtension(file_field, allowedExtensions);
    // let extension = file_field.substr(file_field.lastIndexOf('.') + 1).toLowerCase();
	console.log(flag,"flag")
    if (flag) {
      e.target.value = null;
      toast.error("Please Select Valid file Format. Only " + allowedExtensions.join(", ") + " are allowed.");
      return;
    } else {
      props.setSelectedFileName(file_field)
	  props.setSelectedFileNameData(file[0]);
      //props.setSelectedFileName(e.target.value)
    }

  }
  async function uploadDocumentsFile2(e) {

    let file = e.target.files;
    let file_field = file[0].name;
    let allowedExtensions = ["pdf","png","jpg","gif","svg"];
    let flag = false;
    flag = validateFileExtension(file_field, allowedExtensions);
    // let extension = file_field.substr(file_field.lastIndexOf('.') + 1).toLowerCase();
    if (flag) {
      e.target.value = null;
      toast.error("Please Select Valid file Format. Only " + allowedExtensions.join(", ") + " are allowed.");
      return;
    } else {
      props.setSelectedFileNames(file_field)
	  props.setSelectedFileNamesData(file[0]);
	  console.log(file_field)
      //props.setSelectedFileName(e.target.value)
    }

  }


  async function uploadDocumentsFiles(e) {

    let file = e.target.files;
    let file_field = file[0].name;
    let allowedExtensions = ["pdf","png","jpg","gif","svg"];
    let flag = false;
    flag = validateFileExtension(file_field, allowedExtensions);
    // let extension = file_field.substr(file_field.lastIndexOf('.') + 1).toLowerCase();
    if (flag) {
      e.target.value = null;
      toast.error("Please Select Valid file Format. Only " + allowedExtensions.join(", ") + " are allowed.");
      return;
    } else {
      props.setSelectedFileNames(file_field)
	   props.setSelectedFileNamesData(file[0]);
    }

  }

  const handlePreviousClick = () => {
    // Check if there is a previous tab to switch to
    if (activeTabIndex > 0) {
      setActiveTabIndex(activeTabIndex - 1);
    }
  }
  
  const handleNextClick = () => {
    // console.log("activeTabIndex",activeTabIndex);


    if (!props.checked && activeTabIndex === 0) {
      toast.error('Please Accept Terms & Conditions.');
      return;
    } else if (!props.checked1 && activeTabIndex === 1) {
      toast.error('Please Accept Terms & Conditions of Supplemental Agreement.');
      return;
    } else if (!props.checked2 && activeTabIndex === 2) {
      toast.error('Please Accept Terms & Conditions of Hold Harmless and Indemnification Agreement.');
      return;
    } else if (!props.checked3 && activeTabIndex === 3) {
      toast.error('Please Accept Terms & Conditions of Retirement Status Statement.');
      return;
    } else if (!props.checked4 && activeTabIndex === 4) {
      toast.error('Please Accept Terms & Conditions of Certification Regarding Governor Executive order N-6-22.');
      return;
    }

    // Retriment Status Statement page

    if (props.strs === "" || props.strs === undefined && activeTabIndex === 3) {
      toast.error('Please select Are you a State Teachers Retirement System (STRS) retiree?');
      return;
    }
    else if (props.calpers === "" || props.calpers === undefined && activeTabIndex === 3) {
      toast.error('Please select Are you a California Public Employees Retirement System (CalPERS) retiree?');
      return;
    }

    // EDD & W9
    if (activeTabIndex === 5 && props.selectedFileName === "") {
      toast.error('Please Upload Employment Development Department State of California (EDD) form');
      return;
    }
    else if (activeTabIndex === 5 && props.selectedFileNames === "") {
      toast.error('Please Upload W9 Form (Request for Taxpayer Identification Number and Certification)');
      return;
    }




    // Check if there is a next tab to switch to
    if (activeTabIndex < tabs.length - 1) {
      setActiveTabIndex(activeTabIndex + 1);
    }
  };
  const tabs = ['Tab 1', 'Tab 2', 'Tab 3', 'Tab 4', 'Tab 5', 'Tab 6'];


  return (
    <>



      {/*Col-8*/}
      <div className='col-span-9'>
        <div className='lg:px-[5.573vw] px-[80px] xl:py-[1.667vw] py-[30px]' data-aos="fade-down" data-aos-duration="700" data-aos-delay="500">
          {/*form*/}
          <div className='card termsandcondition customscroll'>
            <div className='text-[#000000] font-bold xl:text-[1.406vw] text-[24px]'>Terms & Conditions</div>
            <div className='cust-tabview mt-[30px]'>
              <Tabs selectedIndex={activeTabIndex} onSelect={(index) => setActiveTabIndex(index)}>
                <TabList>
                  <Tab name="Tab 1">Terms & Conditions</Tab>
                  <Tab name="Tab 2">Supplemental Agreement</Tab>
                  <Tab name="Tab 3">Hold Harmless and Indemnification Agreement</Tab>
                  <Tab name="Tab 4">Retirement Status Statement</Tab>
                  <Tab name="Tab 5">Certification Regarding Governor Executive order N-6-22</Tab>
                  <Tab name="Tab 6">EDD & W9 Details</Tab>
                  {/* <Tab name="Tab 7">{props.tab3}</Tab> */}
                </TabList>
                <TabPanel>
                  <>
                    <div id="pf3" className="pf" data-page-no="3" >
                      <div className='h-[40vw] overflow-hidden xl:overflow-auto psascoll'>
                        <div className="px-10 py-5 text-[#344054] text-[15px] xl:text-[0.885vw]">
                          <div className="text-[24px] text-center xl:text-[1.250vw] font-semibold mb-5">
                            GENERAL TERMS AND CONDITIONS
                          </div>
                          <div className="space-y-2">
                            <div>
                              1. <b>PROPOSAL ACCEPTANCE.</b> Proposals are subject to acceptance by the signing of a contract
                              and issuance of an appropriate purchase order at any time within sixty (60) days after the receipt
                              of quotes unless otherwise stipulated. The District reserves the right to accept or reject any and
                              all quotes and reserves the right to waive any informality in any quote.
                            </div>
                            <div>
                              2. <b>EQUIPMENT AND LABOR.</b> The Provider shall furnish all tools, equipment, apparatus,
                              facilities, transportation, labor, and material necessary to furnish the professional services
                              herein described, the services to be performed at such time and places as directed by and subject
                              to the approval of the authorized district representative indicated in the work specifications
                              attached hereto.
                            </div>
                            <div>
                              3. <b>SAFETY AND SECURITY.</b> It shall be the responsibility of the Provider to ascertain from
                              the District the rules and regulations pertaining to safety, security and driving on school
                              grounds, particularly when children are present.
                            </div>
                            <div>
                              4. <b>TERMINATION.</b> This Contract may be terminated at any time by either party with five (5)
                              business days' advance written notice.
                            </div>
                            <div>
                              5. <b>DEFAULT BY PROVIDER.</b> When Provider shall fail to deliver any article or service or shall
                              deliver any article or service which does not conform to the work specifications, the District
                              may, upon five (5) business days' prior written notice describing the fault, at its option, annul
                              and set aside the contract entered into with said Provider and make and enter into a new contract
                              in such manner as seems to the Board of Education to be to the best advantage of the District. Any
                              failure for furnishing such articles or services by reason of the failure of the Provider as above
                              stated, shall be a liability against the Provider and his sureties. The Board of Education
                              reserves the right to cancel any articles or services which the Provider may be unable to furnish
                              because of economic conditions, governmental regulations or other similar causes beyond the
                              control of the Provider provided satisfactory proof is furnished to the Board of Education, if
                              requested.
                            </div>
                            <div>
                              6. <b>CONTRACT CHANGES.</b> No changes or alterations to this contract shall be made without
                              specific prior written approval by the District.
                            </div>
                            <div>
                              7. <b>SUBSTITUTIONS.</b> No substitutions of materials or service from those specified in the
                              Scope of Work shall be made without the prior written approval of the District.
                            </div>
                            <div>
                              8. <b>ACCESS TO WORK.</b> District representatives shall at all times have access to work wherever
                              it is in preparation or progress.
                            </div>
                            <div>
                              9. <b>PROTECTION OF WORK AND PROPERTY.</b> The Provider shall maintain at all times, as required
                              by conditions and progress of work, all necessary safeguards for the protection of employees and
                              the public. In an emergency affecting life and safety of life or of work or of adjoining property,
                              Provider, without special instruction or authorization from District, is permitted to act at his
                              discretion to prevent such threatened loss or injury.
                            </div>
                            <div>
                              10. <b>ASSIGNMENT OF CONTRACT AND PUCHASE ORDER.</b> The Provider shall not assign or transfer by
                              operation of law or otherwise any or all of its rights, burdens, duties, or obligations under this
                              contract without the prior written consent of the District.
                            </div>
                            <div>
                              11. <b>FORCE MAJEURE CLAUSE.</b> The parties to the Contract shall be excused from performance
                              thereunder during the time and to the extent that they are prevented from obtaining, delivering,
                              or performing by act of God, fire, strike, loss, or shortage of transportation facilities,
                              lock-out commandeering of materials, products, plants or facilities by the government when
                              satisfactory evidence thereof is presented to the other party(ies), provided that it is
                              satisfactorily established that the non-performance is not due to the fault or neglect of the
                              party not performing.
                            </div>
                            <div>
                              12. <b>HOLD HARMLESS AGREEMENT.</b> The Provider shall save, defend, hold harmless and indemnify
                              the District from and against any and all losses, damages, liabilities, claims, and costs of
                              whatsoever kind and nature for injury to or death of any person and for loss or damage to any
                              property occurring in connection with or in any way incident to or arising out of the occupancy,
                              use, service, operations, or performance of work on the property under the terms of this contract,
                              resulting in whole or in part from the negligent acts or omissions of the Provider, any
                              subproviders, or any employee, agent or representative of Provider and/or its subproviders.
                            </div>
                            <div>
                              13. <b>PAYMENT.</b> Unless otherwise specified, the Provider shall render invoices in triplicate
                              for materials delivered or services performed under the Contract/Purchase Order. The District
                              shall make payment for materials, supplies or other services furnished under this Contract as
                              agreed within thirty (30) days after delivery to and approval by the authorized District
                              representative of all invoices and other documentary evidence reasonably required by the District
                              (which approval shall not be unreasonably withheld).
                            </div>
                            <div>
                              14. <b>PERMITS AND LICENSES.</b> The Provider shall secure and maintain in force, at Provider's
                              sole cost and expense, such licenses and permits as are required by law, in connection with the
                              furnishing of services, materials, or supplies herein listed.
                            </div>
                            <div>
                              15. <b>PROVIDER NOT OFFICER, EMPLOYEE, OR AGENT OF DISTRICT.</b> While engaged in carrying out
                              other terms and conditions of the purchase order, the Provider is an independent Provider, and not
                              an officer, employee, agent, partner, or joint venture of the District.
                            </div>
                            <div>
                              16. <b>ANTI-DISCRIMINATION.</b> Pursuant to Board Policy 4030, Glendale Unified School District
                              prohibits discrimination and/or harassment of any person based on race, color, national origin,
                              ancestry, religious creed, age, marital status, pregnancy, physical or mental disability, medical
                              condition, genetic information, veteran status, gender, gender identity, gender expression, sex or
                              sexual orientation. Therefore, the Provider agrees to comply with the applicable Federal and
                              California Laws, including, but not limited to, the California Fair Employment Practice Act,
                              beginning with Labor Code, Section 1410 and Labor Code, Section 1735. In addition, the Provider
                              agrees to require such compliance by all subproviders employed on the Contract by him.
                            </div>
                            <div>
                              17. <b>PROVIDER'S INSURANCE.</b> The Provider shall not commence work under this Contract until he
                              has obtained the insurance required under this paragraph and satisfactory proof of such insurance
                              has been submitted to District and said insurance has been approved by the District. Except for
                              worker's compensation insurance, the policy shall not be amended or modified and the coverage
                              amounts shall not be reduced without the District's prior written consent, and, the District shall
                              be named as an additional insured and be furnished thirty (30) days written notice prior to
                              cancellation. In the event that the insurance requirements cannot be met, please turn in a signed
                              "Hold Harmless and Indemnification Agreement."
                            </div>
                          </div>
                        </div>

                        <div className="px-10 py-5 text-[#344054] text-[15px] xl:text-[0.885vw]">
                          <div className="space-y-2 border-b-[2px] border-[#344054] pb-2">
                            <div>
                              <span className="pl-2">a) </span>{" "}
                              <b>PROVIDER'S PUBLIC LIABILITY AND PROPERTY DAMAGE INSURANCE.</b> The Provider shall procure and
                              shall maintain during the life of his contract, Provider's Public Liability Insurance in an amount
                              not less than $1,000,000 for injuries, including accidental death to any one person, and subject
                              to the limit for each person, in an amount not less than $1,000,000 on account of one accident,
                              and Provider's Property Damage Insurance in an amount not less than $1,000,000.
                            </div>
                            <div>
                              18. <b>COMPLIANCE WITH LAWS.</b> Provider shall give all notices and comply with all laws,
                              ordinances, rules and regulations bearing on conduct or work as indicated or specified. If
                              Provider observes that any of the work required by this contract is at variance with any such
                              laws, ordinances, rules or regulations, Provider shall notify the District, in writing, and, at
                              the sole option of the District, any necessary changes to the scope of work shall be made and this
                              Contract shall be appropriately amended in writing, or this Contract shall be terminated effective
                              upon Provider's receipt of a written termination notice from the District. If Provider performs
                              any work knowing it to be in violation of such laws, ordinances, rules or regulations, and without
                              first notifying the District of such violation, Provider shall bear all costs arising there from.
                            </div>
                            <div>
                              19. <b>TIME IS OF THE ESSENCE.</b> Time is of the essence in the performance of and compliance
                              with each of the provisions and conditions of this contract.
                            </div>
                            <div>
                              20. <b>GOVERNING LAW.</b> This contract shall be governed by and construed in accordance with the
                              laws of the State of California.
                            </div>
                            <div>
                              21. <b>ATTORNEYS' FEES.</b> If any action is brought by either party against the other party
                              hereunder, each party shall be responsible for its own expenses, including legal and accounting
                              fees, in connection with the prosecution or defense of such action.
                            </div>
                            <div>
                              22. <b>NO ORAL MODIFICATION.</b> Any waiver, amendment, modification, consent or acquiescence with
                              respect to this contract or any provision of this contract or with respect to any failure to
                              perform in accordance therewith shall be set forth in writing and duly executed by or on behalf of
                              the party to be bound thereby.
                            </div>
                            <div>
                              23. <b>PROVISIONS REQUIRED BY LAW DEEMED INSERTED.</b> Each and every provision of law and clause
                              required by law to be inserted in this contract shall be deemed to be inserted herein and this
                              contract shall be read and enforced as though it were included herein.
                            </div>
                            <div>
                            24. <b>FINGERPRINTING.</b>The Provider shall be fingerprinted before commencing services of this Contract. 
                            The cost shall be covered by the District.
                            </div>
                            <div>
                              25. <b>TUBERCULOSIS TESTING.</b> Before commencing services, Provider, if working with or near
                              students, shall provide proof of Tuberculosis (TB) testing at their own expense to the Human
                              Resources Department. The TB test must have been conducted within the prior six months to the
                              Contract effective date.
                            </div>
                            <div>
                              26. <b>COVID-19 VACCINATION STATUS.</b> Before commencing services, Provider, if working with or
                              near students, shall provide proof that they are fully vaccinated for COVID-19 within two weeks
                              prior to starting to provide services at a District school site to the Human Resources Department.
                            </div>
                            <div>
                              27. <b>IF WORKING WITH STUDENTS.</b> Any Provider working with a student(s) must be supervised by
                              a credentialed person or must hold an Activity Supervisor Clearance Certificate issued through the
                              California Commission on Teacher Credentialing (CTC).
                            </div>
                            <div>
                              28. <b>TOBACCO/ALCOHOL/DRUG-FREE WORKPLACE.</b> Pursuant to Board Policies 4020 and 4021, Glendale
                              Unified School District is a tobacco, alcohol, and drug-free district. The Provider shall not use
                              or be under the influence of these substances while on District property or during the performance
                              of the services of this Contract. Violation of this policy will result in immediate removal of the
                              Provider from his or her duties and possible immediate termination of this Contract.
                            </div>
                            <div>
                              29. <b>GOVERNOR'S EXECUTIVE ORDER.</b> California Governor Newsom issued Order N-6-22 requiring
                              compliance with the federal Economic Sanction imposed in response to Russia's action in Ukraine.
                              See attached Certification.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="mt-10 ml-10 flex items-center">
                      <div class="flex items-center flex-row">
                        <Checkbox onChange={e => props.setChecked(e.checked)} checked={props.checked}
                          class="appearance-none h-4 w-4 bg-white border border-[#D0D5DD] rounded-[4px] checked:bg-[#113699] checked:scale-75 transition-all duration-200 peer"
                        />

                        <div class="h-4 w-4 absolute rounded-[4px] pointer-events-none peer-checked:border-[#113699] peer-checked:border-2"></div>
                        <label
                          for="cb1"
                          class="flex flex-col justify-center px-2 text-[#344054] font-medium text-sm xl:text-[0.833vw] select-none"
                        >
                          Accept Terms and Conditions{" "}
                        </label>
                      </div>
                      <div className="text-[#667085] text-xs font-normal">
                        <span className="text-[#F00]">*</span>
                      </div>
                    </div>
                  </>
                </TabPanel>
                <TabPanel>
                  <>
                    <div class="pf">
                      <div className=''>
                        <div className="px-10 py-5 text-[#344054] text-[15px] xl:text-[0.885vw] h-[40vw] overflow-auto">
                          <div className="text-center mb-3">
                            <div className="text-[24px] text-center xl:text-[1.250vw] font-semibold ">
                              SUPPLEMENTAL AGREEMENT
                            </div>
                            <div>Specialized Services for Students and Families</div>
                          </div>
                          <div className="mb-3 ">
                            <b>The undersigned Agrees as follows:</b>
                          </div>
                          <div className=" ">
                            <div className="space-y-2">
                              <div>
                                1. To cooperate with school personnel to ensure fair and equitable availability of services to
                                all families.
                              </div>
                              <div>2. To support District and school policies and standards.</div>
                              <div>
                                3. To work with groups of students and/or parents when possible to ensure that as many families
                                are served as possible. Marital counseling is not an expected use of school-based clinical
                                staff.
                              </div>
                              <div>
                                4. To refer students and families in need of (in-depth, long-term) specialized services to
                                appropriate community agencies whenever possible. It is inappropriate for a clinic to refer its
                                own agency unless comparable services are not available elsewhere or the family specifically
                                requests services offered by clinician (which should be documented along with referrals to
                                alternative agencies).
                              </div>
                            </div>
                            <div className="space-y-2">
                              <div>5. To provide licensed personnel or fully-supervised interns for all</div>
                              <div>6. To maintain appropriate insurance as required by the District.</div>
                              {/* <div className="grid grid-cols-2 gap-2 ">
                                <div className="text-center mt-10">
                                  <div>__________________</div>
                                  <div>Signature</div>
                                </div>
                                <div className="text-center mt-10">
                                  <div>___________________</div>
                                  <div>Date</div>
                                </div>
                              </div> */}
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                    <div className="mt-10 ml-10 flex items-center">
                      <div class="flex items-center flex-row">
                        <Checkbox onChange={e => props.setChecked1(e.checked)} checked={props.checked1}
                          class="appearance-none h-4 w-4 bg-white border border-[#D0D5DD] rounded-[4px] checked:bg-[#113699] checked:scale-75 transition-all duration-200 peer"
                        />
                        {/*  <input
                          type="checkbox"
                          id="cb1"
                          value="cb1"
                          class="appearance-none h-4 w-4 bg-white border border-[#D0D5DD] rounded-[4px] checked:bg-[#113699] checked:scale-75 transition-all duration-200 peer"
                        /> */}
                        <div class="h-4 w-4 absolute rounded-[4px] pointer-events-none peer-checked:border-[#113699] peer-checked:border-2"></div>
                        <label
                          for="cb1"
                          class="flex flex-col justify-center px-2 text-[#344054] font-medium text-sm xl:text-[0.833vw] select-none"
                        >
                          Accept Supplemental Agreement{" "}
                        </label>
                      </div>
                      <div className="text-[#667085] text-xs font-normal">
                        <span className="text-[#F00]">*</span>
                      </div>
                    </div>
                  </>
                </TabPanel>
                <TabPanel>
                  <>
                    <div id="pf5" className="pf h-[40vw] overflow-auto" data-page-no="5">
                      <div className="px-10 py-5 text-[#344054] text-[15px] xl:text-[0.885vw]">
                        <div className="text-center mb-5">
                          <div className="text-[24px] xl:text-[1.250vw] font-semibold">Glendale Unified School District</div>
                          <div className="text-[15px] xl:text-[0.781vw] font-semibold mb-5">Glendale, California</div>
                          <div className="text-[24px] xl:text-[1.250vw] font-semibold">
                            HOLD HARMLESS AND INDEMNIFICATION AGREEMENT
                          </div>
                        </div>
                        <div>
                          Provider agrees at all times to protect, indemnify, and hold the Glendale Unified School District,
                          its Board of Trustees, sofficers, employees, members, representatives, agents, guests, invitee,
                          and/or employees free and harmless, and to provide legal defense, from any and all liabilities,
                          claims, losses, judgments, damage, demands or expenses resulting from the services provided by the
                          Provider, Provider's use or occupancy of the District's facilities and premises [including travel to
                          and from said facilities and premises] and/or the active or passive negligence of the Provider or of
                          the District, its Board of Trustees, officers, employees, members, representatives, agents, guests,
                          invitee, and/or employees, specifically including, without limitation, any liability, claim, loss,
                          judgment, damage, demand, or expense, arising by reason of:
                        </div>
                        <div className="space-y-2 px-8 mt-2">
                          <div className="flex gap-2">
                            <div>1.</div>
                            <div>
                              the loss of or damage to any of the District's facilities or premises including any building,
                              structure, or improvement thereon, or any equipment to be used therein;
                            </div>
                          </div>
                          <div className="flex gap-2">
                            <div>2.</div>
                            <div>
                              the injury to or death of any person including, but not limited to, the officers, members,
                              employees, representatives, agents, guests, invitee, and/or employees of the Provider or of the
                              District; or
                            </div>
                          </div>
                          <div className="flex gap-2">
                            <div>3.</div>
                            <div>
                              damage to any property arising from the use, possession, selection, delivery, return, condition
                              or operation of the District's facilities.
                              <div className="mt-2">
                                Provider further agrees to reimburse the District for all liabilities, claims, losses,
                                judgments, damage, demands, expenses, fines, penalties, including reasonable attorneys' fees
                                imposed or incurred by the District because of the Provider's use or occupancy of the
                                District's facilities, access to said facilities and premises, and/or active or passive
                                negligence of the Provider or of the District, its Board of Trustees, officers, members,
                                representatives, agents, guests, invitee, and/or employees.
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mt-2">
                          THE UNDERSIGNED HAS READ AND VOLUNTARILY SIGNS THE RELEASE AND WAIVER OF LIABILITY AND INDEMNITY
                          AGREEMENT, and further agrees that no oral representation, statements of inducement apart from the
                          foregoing written agreement have been made.
                        </div>
                        {/* <div className="mt-2">
                          <div className="grid grid-cols-1 xl:grid-cols-2 gap-2">
                            <div className="space-y-10">
                              <div></div>
                              <div>
                                <div>______________________</div>
                                <div>Date</div>
                              </div>
                            </div>
                            <div className="space-y-10">
                              <div>I HAVE READ THIS RELEASE.</div>
                              <div>
                                <div>_________________________</div>
                                <div>Signature of Provider</div>
                              </div>
                              <div>
                                <div>_________________________</div>
                                <div>Print Name</div>
                              </div>
                            </div>
                          </div>
                        </div> */}
                      </div>
                    </div>
                    <div className="mt-10 ml-10 flex items-center">
                      <div class="flex items-center flex-row">
                        <Checkbox onChange={e => props.setChecked2(e.checked)} checked={props.checked2}
                          class="appearance-none h-4 w-4 bg-white border border-[#D0D5DD] rounded-[4px] checked:bg-[#113699] checked:scale-75 transition-all duration-200 peer"
                        />

                        <div class="h-4 w-4 absolute rounded-[4px] pointer-events-none peer-checked:border-[#113699] peer-checked:border-2"></div>
                        <label
                          for="cb1"
                          class="flex flex-col justify-center px-2 text-[#344054] font-medium text-sm xl:text-[0.833vw] select-none"
                        >
                          Accept Hold Harmless and Indemnification Agreement{" "}
                        </label>
                      </div>
                      <div className="text-[#667085] text-xs font-normal">
                        <span className="text-[#F00]">*</span>
                      </div>
                    </div>
                  </>
                </TabPanel>
                <TabPanel>
                  <>
                    <div id="pf6" class="pf " data-page-no="6">
                      <div className="px-10 py-5 text-[#344054] text-[15px] xl:text-[0.885vw]">
                        <div className="text-center mb-10">
                          <div className="text-[24px] xl:text-[1.250vw] font-semibold">Glendale Unified School District</div>
                          <div className="text-[15px] xl:text-[0.781vw] font-semibold mb-5">Glendale, California</div>
                          <div className="text-[24px] xl:text-[1.250vw] font-semibold mb-5">Personal Services Agreement</div>
                          <div className="text-[24px] xl:text-[1.250vw] font-semibold">Retirement Status Statement</div>
                        </div>
                        <div className="flex items-center gap-1">
                          <div className="mb-4"><span className="text-[#F00]">*</span>Are you a State Teachers Retirement System (STRS) retiree?
                          </div>
                        </div>
                        <div className="flex flex-wrap justify-content-center gap-3 mb-10">
                          <div className="flex align-items-center">
                            <input type="radio" id="Yes" name="Radio1" checked={props.strs}
                              onChange={e => {
                                props.setStrs(true)
                              }} />
                            <label for="html">Yes</label>
                          </div>
                          <div className="flex align-items-center">
                            <input type="radio" id="No" name="Radio1" value="" checked={props.strs !== undefined && !props.strs}
                              onChange={e => {
                                props.setStrs(false)
                              }} />
                            <label for="css">No</label>
                          </div>
                        </div>
                        <div className="flex items-center gap-1">
                          <div className="mb-4"><span className="text-[#F00]">*</span>Are you a California Public Employees Retirement System (CalPERS) retiree?</div>

                        </div>
                        <div className="flex flex-wrap justify-content-center gap-3 mb-10">
                          <div className="flex align-items-center">
                            <input type="radio" id="Yes2" name="Radio2" value="" checked={props.calpers} onChange={e => props.setCalpers(true)} />
                            <label for="html">Yes</label>
                          </div>
                          <div className="flex align-items-center">
                            <input type="radio" id="No2" name="Radio2" value="" checked={props.calpers !== undefined && !props.calpers} onChange={e => props.setCalpers(false)} />
                            <label for="css">No</label>
                          </div>
                        </div>
                        {/* <div className="flex items-center gap-1">
                    <div className="mb-4"> Are you a State Teachers Retirement System (STRS) retiree?</div>
                   
                  </div>
                  <div className="flex flex-wrap justify-content-center gap-3 mb-10">
                    <div className="flex align-items-center">
                      <input type="radio" id="Yes" name="Radio3" value="" onChange={e => setCheckYes1(e.checked)} />
                      <label for="html">Yes</label>
                    </div>
                    <div className="flex align-items-center">
                      <input type="radio" id="No" name="Radio3" value="" onChange={e => setCheckNo1(e.checked)} />
                      <label for="css">No</label>
                    </div>
                  </div> */}

                        <div className="mb-28">
                          Note: The District will be reporting your earnings or hours to the appropriate retirement system.
                          You are responsible for monitoring your work hours or earnings to make sure you do not exceed your
                          retirement limit.
                        </div>
                        {/* <div className="space-y-10">
                          <div>
                            <div>___________________________________</div>
                            <div>Name (Print)</div>
                          </div>
                          <div>
                            <div>___________________________________</div>
                            <div>Signature of Provider</div>
                          </div>
                          <div>
                            <div>___________________________________</div>
                            <div>Date</div>
                          </div>
                        </div> */}
                      </div>
                    </div>
                    <div className="mt-10 ml-10 flex items-center">
                      <div class="flex items-center flex-row">
                        <Checkbox onChange={e => props.setChecked3(e.checked)} checked={props.checked3}
                          class="appearance-none h-4 w-4 bg-white border border-[#D0D5DD] rounded-[4px] checked:bg-[#113699] checked:scale-75 transition-all duration-200 peer"
                        />

                        <div class="h-4 w-4 absolute rounded-[4px] pointer-events-none peer-checked:border-[#113699] peer-checked:border-2"></div>
                        <label
                          for="cb1"
                          class="flex flex-col justify-center px-2 text-[#344054] font-medium text-sm xl:text-[0.833vw] select-none"
                        >
                          Please select the checkbox to confirm Retirement Status Statement{" "}
                        </label>
                      </div>
                      <div className="text-[#667085] text-xs font-normal">
                      <span className="text-[#F00]">*</span>
                       
                      </div>
                    </div>
                  </>
                </TabPanel>
                <TabPanel>
                  <>
                    <div id="pf7" className="pf h-[40vw] overflow-auto" data-page-no="7">
                      <div className="px-10 py-5 text-[#344054] text-[15px] xl:text-[0.885vw] ">
                        <div className="text-center mb-10">
                          <div className="text-[24px] xl:text-[1.250vw] font-semibold">Glendale Unified School District</div>
                          <div className="text-[15px] xl:text-[0.781vw] font-semibold mb-5">Glendale, California</div>
                          <div className="text-[24px] xl:text-[1.250vw] font-semibold mb-1">CERTIFICATION REGARDING</div>
                          <div className="text-[24px] xl:text-[1.250vw] font-semibold">
                            <u> GOVERNOR EXECUTIVE ORDER N-6-22</u>
                          </div>
                        </div>

                        <div className="mb-2">
                          On March 4, 2022, California Governor Newsom issued Order N-6-22 requiring state agencies to take
                          steps to ensure any agency and entity under contract with state agencies comply with the Federal
                          Order:
                        </div>
                        <div className="mb-4">
                          (<u>https://www.gov.ca.gov/wp-content/uploads/2022/03/3.4.22-Russia-Ukraine-Executive-Order.pdf;</u>{" "}
                          "State Order").
                        </div>
                        <div className="mb-2">
                          if you enter into a contract with the District, you must comply with the economic sanctions imposed
                          in response to Russia's actions in Ukraine, including the orders and sanctions identified on the
                          U.S. Department of the Treasury website:
                        </div>
                        <div className="text-center mb-4">
                          (
                          <u>
                            https://home.treasury.gov/policy-issues/financial-sanctions/sanctions-programs-and-country-information/ukraine-russia-related-sanctions).
                          </u>
                        </div>
                        <div className="mb-4">
                          As part of this procurement, <b>if the contract value of this procurement is $5 million or more,</b>{" "}
                          please include in your Response the following:
                        </div>
                        <div className="space-y-2 px-8">
                          <div>
                            (1) a statement that you are in compliance with the required economic sanctions of the Federal and
                            State Orders;
                          </div>
                          <div>
                            (2) the steps you have taken in response to Russia's actions in Ukraine, including, but not
                            limited to, desisting from making new investments in, or engaging in financial transactions with,
                            Russian entities, not transferring technology to Russia or Russian entities, and directly
                            providing support to the government and people of Ukraine.
                          </div>
                        </div>
                        {/* <div className="flex gap-20 mt-10">
                          <div className="space-y-4">
                            <div>Print Name:</div>
                            <div>Signature:</div>
                            <div>Date:</div>
                          </div>
                          <div className="space-y-4">
                            <div>_________________________________</div>
                            <div>_________________________________</div>
                            <div>_________________________________</div>
                          </div>
                        </div> */}
                      </div>
                    </div>
                    <div className="mt-10 ml-10 flex items-center">
                      <div class="flex items-center flex-row">
                        <Checkbox onChange={e => props.setChecked4(e.checked)} checked={props.checked4}
                          class="appearance-none h-4 w-4 bg-white border border-[#D0D5DD] rounded-[4px] checked:bg-[#113699] checked:scale-75 transition-all duration-200 peer"
                        />

                        <div class="h-4 w-4 absolute rounded-[4px] pointer-events-none peer-checked:border-[#113699] peer-checked:border-2"></div>
                        <label
                          for="cb1"
                          class="flex flex-col justify-center px-2 text-[#344054] font-medium text-sm xl:text-[0.833vw] select-none"
                        >
                          Accept Terms and Conditions (Certification Regarding Governor  Executive order N-6-22)
                        </label>
                      </div>
                      <div className="text-[#667085] text-xs font-normal">
                      <span className="text-[#F00]">*</span>
                      </div>
                    </div>
                  </>
                </TabPanel>
                <TabPanel>
                  <div id="pf7" className="pf h-[32vw] overflow-auto px-10" data-page-no="7">
                    <div className='text-[#101828] font-medium text-sm xl:text-[0.833vw] -tracking-[0.32px] mt-[22px] mb-[20px]'>EDD & W9 Details</div>

                    <div className='grid grid-cols-2 xl:gap-[2.083vw] gap-[20px]'>
                      {/*col*/}
                      <div>
                        <div className='text-[#101828] font-normal text-xs xl:text-[0.729vw] -tracking-[0.28px] leading-7 mb-1'>Upload Employment Development Department State of California (EDD) form :
                          <span className="text-[#F00]">*</span>
                        </div>
                        <div className='border-dashed border border-[#7093FF] bg-[rgba(234,239,255,0.25)] rounded-[10px] xl:p-[1.042vw] p-[18px]'>
                          <div class="flex items-center justify-center w-full">
                            <label for="dropzone-file" class="flex flex-col items-center justify-center w-full cursor-pointer">
                              <div class="flex flex-col items-center justify-center pt-5 pb-6">
                                <div className='bg-[#F2F4F7] text-[#667085] border border-[#F9FAFB] rounded-full xl:p-[0.521vw] p-[8px]'><i className='upload-cloud'></i></div>
                                <div className='mt-2'><p class="mb-2 text-sm text-[#667085]"><span class="font-semibold text-[#113699]">Click to upload</span> or drag and drop</p>
                                  <p class="text-xs text-[#667085]">SVG, PNG, JPG, GIF or PDF (MAX. 800x400px)</p>
                                </div>

                                {/* <div className="mt-2 text-[#101828] text-sm xl:text-[0.833vw] font-medium -tracking-[0.32px]">{selectedFileName}</div> */}
                                {
                                  props.selectedFileName ?
                                    <div className='items-center mt-[6px]'>
                                      <div className='flex items-center gap-2'>
                                        <div className='bg-white border border-[#DDE8EB] py-2 px-1 pdf_shadow rounded-md'><i className='PDF_file_Icon'></i></div>
                                        <div className="flex gap-2">
                                          <div className='text-[#101828] text-sm xl:text-[0.833vw] font-medium -tracking-[0.32px]'>{props.selectedFileName.replace(/^.*[\\\/]/, '')}</div>
                                          <i className="pi pi-times mt-1.5" style={{ fontSize: "11px" }}
                                            onClick={(e) => { props.setSelectedFileName('') }}
                                          ></i>
                                        </div>
                                      </div>

                                    </div> : <div className='text-[#667085] text-sm xl:text-[0.833vw] font-medium -tracking-[0.32px]'>No File Selected</div>
                                }

                              </div>
                              <input id="dropzone-file"
                                onChange={(e) => { uploadDocumentsFile(e) }}
                                type="file" class="hidden" />
                            </label>
                          </div>

                          <div className='flex justify-between items-center mt-[20px] pt-[20px] border-t border-[rgba(112,147,255,0.26)]'>
                            <div className='flex items-center gap-2'>
                              <div className='bg-white border border-[#DDE8EB] py-2 px-1 pdf_shadow rounded-md'><i className='PDF_file_Icon'></i></div>
                              <div>
                                <div className='text-[#101828] text-sm xl:text-[0.833vw] font-medium -tracking-[0.32px]'>EDD Form .pdf  </div>
                                <div className='text-[#667085] text-xs xl:text-[0.677vw] font-normal -tracking-[0.24px]'>1.34 MB</div>
                              </div>
                            </div>

                            <a href="#" className='flex items-center space-x-2 text-[#3366FF] text-xs xl:text-[0.729vw] font-medium -tracking-[0.28px] cursor-pointer' onClick={(e) => downloadFile("EDD.pdf", 'public/importFile/EDD.pdf')}>
                              <i className='Download_Icon'></i><span>Download</span>
                            </a>

                          </div>

                        </div>
                      </div>
                      {/*col*/}
                      {/*col*/}
                      <div>
                        <div className='text-[#101828] font-normal text-xs xl:text-[0.729vw] -tracking-[0.28px] leading-7 mb-1'>Upload W9 Form (Request for Taxpayer Identification Number and Certification) :
                          <span className="text-[#F00]">*</span>
                        </div>
                        <div className='border-dashed border border-[#7093FF] bg-[rgba(234,239,255,0.25)] rounded-[10px] xl:p-[1.042vw] p-[18px]'>
                          <div class="flex items-center justify-center w-full">
                            <label for="dropzone-files" class="flex flex-col items-center justify-center w-full cursor-pointer">
                              <div class="flex flex-col items-center justify-center pt-5 pb-6">
                                <div className='bg-[#F2F4F7] text-[#667085] border border-[#F9FAFB] rounded-full xl:p-[0.521vw] p-[8px]'><i className='upload-cloud'></i></div>
                                <div className='mt-2'><p class="mb-2 text-sm text-[#667085]"><span class="font-semibold text-[#113699]">Click to upload</span> or drag and drop</p>
                                  <p class="text-xs text-[#667085]">SVG, PNG, JPG , GIF or PDF (MAX. 800x400px)</p>
                                </div>
                                {
                                  props.selectedFileNames ?
                                    <div className='items-center mt-[6px]'>
                                      <div className='flex items-center gap-2'>
                                        <div className='bg-white border border-[#DDE8EB] py-2 px-1 pdf_shadow rounded-md'><i className='PDF_file_Icon'></i></div>
                                        <div className="flex gap-2">
                                          <div className='text-[#101828] text-sm xl:text-[0.833vw] font-medium -tracking-[0.32px]'>{props.selectedFileNames.replace(/^.*[\\\/]/, '')}</div>
                                          <i className="pi pi-times mt-1.5" style={{ fontSize: "11px" }}
                                            onClick={(e) => { props.setSelectedFileNames('') }}
                                          ></i>
                                        </div>
                                      </div>
                                    </div> : <div className='text-[#667085] text-sm xl:text-[0.833vw] font-medium -tracking-[0.32px]'>No File Selected</div>
                                }
                              </div>
                              <input
                                id="dropzone-files"
                                type="file"
                                onChange={(e) => { uploadDocumentsFile2(e) }}
                                class="hidden" />
                            </label>
                          </div>

                          <div className='flex justify-between items-center mt-[20px] pt-[20px] border-t border-[rgba(112,147,255,0.26)]'>
                            <div className='flex items-center gap-2'>
                              <div className='bg-white border border-[#DDE8EB] py-2 px-1 pdf_shadow rounded-md'><i className='PDF_file_Icon'></i></div>
                              <div>
                                <div className='text-[#101828] text-sm xl:text-[0.833vw] font-medium -tracking-[0.32px]'>W9 Form .pdf  </div>
                                <div className='text-[#667085] text-xs xl:text-[0.677vw] font-normal -tracking-[0.24px]'>1.34 MB</div>
                              </div>
                            </div>

                            <a href="#" className='flex items-center space-x-2 text-[#3366FF] text-xs xl:text-[0.729vw] font-medium -tracking-[0.28px] cursor-pointer' onClick={(e) => downloadFile("W9.pdf", 'public/importFile/W9.pdf')}>
                              <i className='Download_Icon'></i><span>Download</span>
                            </a>

                          </div>

                        </div>
                      </div>
                      {/*col*/}
                    </div>
                  </div>
                  <div className='mt-10 ml-10 flex items-center'>
                      <div class='flex items-center flex-row'>
                        <Checkbox onChange={e => props.setChecked5(e.checked)} checked={props.checked5}
                          class="appearance-none h-4 w-4 bg-white border border-[#D0D5DD] rounded-[4px] checked:bg-[#113699] checked:scale-75 transition-all duration-200 peer"
                        />

                        <div class='h-4 w-4 absolute rounded-[4px] pointer-events-none peer-checked:border-[#113699] peer-checked:border-2'>
                        </div>
                        <label for='cb1' class='flex flex-col justify-center px-2 text-[#344054] font-medium text-sm xl:text-[0.833vw] select-none'>Please select the checkbox to confirm that you have filled out and uploaded the W9 and EDD forms </label>
                      </div>
                      <div className='text-[#667085] text-xs font-normal'><span className='text-[#F00]'>*</span></div>
                    </div>
                </TabPanel>
              </Tabs>
            </div>
          </div>

          <div className='flex flex-wrap items-center justify-center md:justify-end xl:gap-[0.521vw] gap-[8px] mt-10'>

            <div className="inline-block text-[#344054] text-[16px] xl:text-[0.833vw] font-medium bg-white hover:bg-[#f5f5f5] border border-[#D0D5DD] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] cursor-pointer"
              onClick={() => {
                handlePreviousClick();
                if(activeTabIndex === 0){
                  props.setTab1(true);
                  props.setTab2(false);
                  props.setTab3(false);
                }

                

              }}><span>Previous</span></div>

            <div className="inline-block text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#113699] hover:bg-[#0f296e] border border-[#113699] hover:border-[#0f296e] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] cursor-pointer"
              // onClick={() => {
              //                     // props.setTab1(false);
              //                     // props.setTab2(false);
              //                     // props.setTab3(true);

              //                   }}

              onClick={() => {
                handleNextClick();
                if (activeTabIndex === 5) {
                  if (props.selectedFileName !== '' && props.selectedFileNames !== '') {
                    if (!props.checked5 && activeTabIndex === 5) {
                      toast.error('Please Accept Terms & Conditions of EDD & W9 Details.');
                      return;
                    }
                    props.setTab3(true)
                    props.setTab1(false)
                    props.setTab2(false)
                  }
                }
              }}
            ><span>Next</span></div>
            {/* <div className='xl:py-[0.833vw] py-[14px] xl:px-[1.458vw] px-[24px] text-[#101828] rounded-lg font-semibold text-sm xl:text-[0.833vw] space-x-2 cursor-pointer'><i className='gusd-close text-xs'></i><span>Cancel</span></div>
                    <div className='xl:py-[0.833vw] py-[14px] xl:px-[1.458vw] px-[24px] text-[#D92D20] rounded-lg font-semibold text-sm xl:text-[0.833vw] space-x-2 cursor-pointer'><i className='gusd-close-circle-bold text-base'></i><span>Reject</span></div>
                    <div className='xl:py-[0.833vw] py-[14px] xl:px-[1.458vw] px-[24px] bg-[#113699] text-white rounded-lg font-semibold text-sm xl:text-[0.833vw] space-x-2 cursor-pointer'><i className='gusd-check-circle text-sm'></i><span>Confirm</span></div>
				*/}
          </div>

          {/*form*/}



        </div>
      </div>
      {/*Col-8*/}


    </>
  );
}